import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"card py-1 px-3",class:_vm.classesCss,on:{"click":_vm.selecao}},[_c('p',{staticClass:"font-16 pt-1",domProps:{"textContent":_vm._s(_vm.card.titulo)}}),(!_vm.loading)?_c('p',{staticClass:"font-26 font-weight-bold",domProps:{"textContent":_vm._s(_vm.card.total)}}):_c(VProgressLinear,{staticClass:"mt-4",attrs:{"indeterminate":"","rounded":"","color":"red"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }